import React, {PureComponent, ChangeEvent, CSSProperties} from 'react'
import cxs from 'cxs'
import Theme from 'Theme'
import {t} from 'helpers/i18n'
import {TextArea} from 'elements'

interface Props {
  name: string
  column?: string
  type: string
  value: string | number | undefined
  required?: boolean
  onChange(name: string, value: string, column?: string): void
}

class FieldTextArea extends PureComponent<Props, object> {
  handleChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
    const value = event.target.value.replace(/[\n\r]{2,}/g, '')
    this.props.onChange(this.props.name, value, this.props.column)
  }

  render() {
    const {name, type, value, required, onChange, ...props} = this.props
    return (
      <TextArea
        {...props}
        label={t(name) + (required ? '*' : '')}
        type={type}
        value={value}
        className={className}
        onChange={this.handleChange}
      />
    )
  }
}

export default FieldTextArea

const className = cxs({
  padding: Theme.size.space[1]
} as CSSProperties)



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/elements/FieldTextArea.tsx